
import { useNavigate } from 'react-router-dom';

// @mui material components
import Grid from "@mui/material/Grid";

// Material Dashboard 2 React components
import MDBox from "../components/MDBox";

// dependencies
import { useEffect, useState } from "react";
// import { toast } from "react-toastify";

// Material Dashboard 2 React example components
import { Container } from "@mui/material";
import WorkspacePremiumOutlinedIcon from '@mui/icons-material/WorkspacePremiumOutlined';

// utilities
import ReceiptIcon from '@mui/icons-material/Receipt';
import Pagination from "../components/lbic_component/Pagination";
import BasicTable from "../components/lbic_component/Table";

// css
import "../assets/CSS/index.css";
import { ClientCall } from "../context/allotees/apiClass";
import ModalMessenger from "../components/lbic_component/Modal";
import Invoice from './Invoice';
import Certificate from './Certificate';
import { connect } from 'react-redux';

export const ButtonDisplayPayment = (props) => {

  return (
    <div>
      <span className="actionbtn" id="id_invo" onClick={props.displayPremPayment}>
        <ReceiptIcon fontSize="20"/>
      </span>
      <span className="actionbtn" id="id_cert" onClick={props.showCertificate}>
        <WorkspacePremiumOutlinedIcon fontSize="20"/>
      </span>
    </div>
  );
};

function PremiumPaymentsHistory({ allotee }) {
  const [premiumPayments, setPremiumPayments] = useState([]);
  const [dataPerPage, setDataPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [show, setShow] = useState(false);
  const [onePremData, setOnePremData] = useState({});
  const [showCert,setShowCertificate] = useState(false)
  const [alloteeD,setAllotee] = useState({})

  const navigate = useNavigate();

  useEffect(() => {
    ClientCall(null,'get','/showAlloteeTransaction',null,callback,errCallback,'null','allotee')
  }, []);

  const indexOfLastData = currentPage * dataPerPage;
  const indexOfFirstData = indexOfLastData - dataPerPage;
  let currentDatas = premiumPayments.length > 0 ? premiumPayments.slice(indexOfFirstData, indexOfLastData): []

  const callback = (response) => {
    let transaction = {};
    let transArr = []
    for (const key in transaction = response.Transactions) {
      transArr.push(transaction[key])
      if(Object.keys(transaction).length === transArr.length){
        setPremiumPayments(transArr);
      }
    }
  };

  const errCallback = () => {
    console.log("Unsuccessful Request");
  };

  // Function close modal when open
  const handleClose = () => {
    if(show){setShow(false)}else {
      setAllotee({})
      setShowCertificate(false)}};

  const displayPremPayment = (props) => {
    setShow(true);
    setOnePremData(props);
    setAllotee(allotee)
  };

  const showCertificate = (props) => {
    setOnePremData(props);
    setShowCertificate(true)
  };

  const ActionElement = {
    component: 'div',
    children: [
      {
        component: 'span',
        onclick: displayPremPayment,
        className: 'actionbtn',
        children: <ReceiptIcon fontSize="20"/>
      },
      {
        component: 'span',
        'onclick': showCertificate,
        className: 'actionbtn',
        children: <WorkspacePremiumOutlinedIcon fontSize="20"/>
      }
    ]
  }


  return (
    <Container className="container-dashboard">
      <ModalMessenger
        open={show}
        handleClose={handleClose}
        body={<Invoice payment={onePremData}/>}
        width="lg"
      />
      <ModalMessenger 
        open={showCert}
        handleClose={handleClose}
        body={<Certificate certificate={onePremData} allotee={allotee} />}
        width="lg"
      />
      <MDBox py={3}>
        <Grid container spacing={3}>
          <Grid item xs={12} md={12} lg={12}>
            <Pagination
              dataPerPage={dataPerPage}
              totalData={premiumPayments.length}
              currentPage={currentPage}
              setCurrentPage={setCurrentPage}
              range={3}
            />
            {/* <MDBox mb={1.5}>
              <Typography>All Registered Allotees</Typography>
            </MDBox> */}
          </Grid>
        </Grid>
        <MDBox mt={4.5}>
          <BasicTable
            style={{ width: "100%" }}
            heading={[
              "Cover Plan",
              "Cover Price",
              "Start Date",
              "Due Date",
              "Date Paid",
              "Actions",
            ]}
            values={["coverFlat", "id", "start_date", "expire_date", "created_at"]}
            data={currentDatas}
            color="#343a40"
            actionComponent={ActionElement}
            toFormat={['start_date time','expire_date time','created_at time']}
            type={['time', 'currency']}
          />
        </MDBox>
        <MDBox>
          <Grid container spacing={3}>
            <Grid item xs={12} md={6} lg={8}></Grid>
            <Grid item xs={12} md={6} lg={4}></Grid>
          </Grid>
        </MDBox>
      </MDBox>
    </Container>
  );
}

export default connect(state =>  ({allotee: state.alloteeReducer.currentUser}))(PremiumPaymentsHistory);
